// Control sizes. lg is the default — the 40px single-line field (56px with the
// label inside) is the design baseline; sm/md step it down, mirroring the
// SelectDropdown size scale convention.
export const FORM_INPUT_SIZE = {
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};

export const FORM_INPUT_SIZES = new Set(Object.values(FORM_INPUT_SIZE));

// Where the field label renders: above the box (classic form layout, default)
// or inside it (the "softbox" design — small grey label on the first line).
export const FORM_INPUT_LABEL_PLACEMENT = {
    OUTSIDE: 'outside',
    INSIDE: 'inside',
};

export const FORM_INPUT_LABEL_PLACEMENTS = new Set(Object.values(FORM_INPUT_LABEL_PLACEMENT));
